import React from 'react';
import PropTypes from 'prop-types';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__content">
        <p className="footer__text">
          Built with React and modern web technologies
        </p>
        <div className="footer__links">
          <a href="#privacy" className="footer__link">Privacy Policy</a>
          <a href="#terms" className="footer__link">Terms of Service</a>
          <a href="#contact" className="footer__link">Contact</a>
          <a href="#github" className="footer__link">GitHub</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
